import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from 'react-redux'
import ReCAPTCHA from "react-google-recaptcha";
import { Toast } from 'primereact/toast';

import { Button } from "../../../helpers";

import { fetchUserRoles, setToken } from '../../../services/redux/reducers/user/user'
import { raiseToast } from "../../../services/redux/reducers/toast/toast";
import { resendEmailOtp, otpVerification } from '../../../services/api/auth';


const VerifyOtp = (props) =>{

    const { userDetails, handleLoginToggle, hash, setHash } = props

    const [resendOTPTimer, setResedOTPTimer] = useState(30)
    const [isActiveResendOTP, setIsActiveResendOTP] = useState(false)
    const [otp, setOTP] = useState(['', '', '', ''])
    const focusValue = [useRef(), useRef(), useRef(), useRef()]
    const [captchaToken, setCaptchaToken] = useState(null)
    const captchaRef = useRef(null)

    const resendOTPTimerId = useRef(null)
    const toast = useRef(null)
    const navigate = useNavigate()
    const dispatch = useDispatch()

    useEffect(() => {
        resendOTPTimerId.current = setInterval(() => {
            setResedOTPTimer(prevState => prevState - 1)
        }, 1000)

        return () => {
            clearInterval(resendOTPTimerId.current)
            console.log('clear intervel executed!')
        }
    }, [])

    useEffect(() => {
        if(resendOTPTimer <= 0){
            clearInterval(resendOTPTimerId.current)
            setResedOTPTimer(30)
            setIsActiveResendOTP(true)
        }
    }, [resendOTPTimer])

    const handleOtpInput = (index, value) => {
        const allNumbersRegexCode = /^\d$/
        const singleNumberRegxCode = /^\d+$/

        let newValue = ''
        if(allNumbersRegexCode.test(value)){
            newValue = value
        }else if (singleNumberRegxCode.test(value)){
            newValue = value[0]
        }
        else if(allNumbersRegexCode.test(value[0])){
            newValue = value[0]
        }

        const newInputValues = [...otp]
        newInputValues[index] = newValue
        setOTP(newInputValues)

        if (value.length > 0 && index < focusValue.length - 1 && newValue !== '') {
            focusValue[index + 1].current.focus()
        }

    };

    const handlekeyDown = (index, event) => {
        if (event.key === 'Backspace' && event.target.value === '' && index > 0) {
            focusValue[index - 1].current.focus()
        }
    }

    const handleCaptchaChange = (token) => {
        setCaptchaToken(token)
    }

    const handleOTPSubmit = async (event) => {
        event.preventDefault()

        if (!captchaToken) {
            return dispatch(raiseToast({severity:'error', detail: 'Please complete the CAPTCHA' }))
        }

        let otpCode = otp.join('')
        if(otpCode.length !== 4){
            return toast.current.show({severity:'error', summary: 'Error', detail:"Please Enter Otp", life: 3000})
        }
        otpCode = parseInt(otpCode)
        
        const numberValidationRegxCode = /^[0-9]+$/
        const numberValidation = numberValidationRegxCode.test(userDetails)

        const data = numberValidation ? { phoneNum: userDetails, code: otpCode, hash: hash, captchaToken } : { email: userDetails, code: otpCode, hash: hash, captchaToken }
        const response = await otpVerification(data)
        
        if(response.status === 400){
            setOTP(['', '', '', ''])
            focusValue[0].current.focus()

            //const error = response.data.errorCode.replace('_',' ').toLowerCase()
            return toast.current.show({severity:'error', detail:response.data.error, life: 3000})
        }
        else{
            const useCache = false
            dispatch(fetchUserRoles(useCache))
            dispatch(setToken())

            navigate('/')
        }
    }

    const handleResentOtp = async () => {
        setIsActiveResendOTP(false)
        resendOTPTimerId.current = setInterval(() => {
            setResedOTPTimer(prevState => prevState - 1)
        }, 1000)

        const numberValidationRegxCode = /^[0-9]+$/
        const numberValidation = numberValidationRegxCode.test(userDetails)
        const data = numberValidation ? { phoneNum: userDetails } : { emailId: userDetails }
        
        const response = await resendEmailOtp(data)
        setHash(response.data)

        return toast.current.show({severity:'success', summary: 'Success', detail:"An Otp was sent to your email", life: 3000})
    }

    const seconds = resendOTPTimer < 10 ? '0' + resendOTPTimer : resendOTPTimer
    
    return(
        <div className=" flex flex-column sm:mt-3 lg:flex-column col-12 lg:col-12">
            <div className="login-box mt-3 col-10">
                <Toast ref={toast} />
                <form className="login-box-content" onSubmit={handleOTPSubmit}>
                    <p className="m-0 back-text" onClick={() => {handleLoginToggle(false)}}>{'<Back'}</p>
                    <input disabled placeholder={userDetails} className="otp-verification-input" />
                    <div className=" flex col-12 text-center">
                        <p className=" flex flex-column text-sm align-item-center my-2"> An OTP has been sent to your email please verify it below</p>
                    </div>
                    <div className="grid justify-content-center">
                        {otp.map((value, index) => (
                            <div className=" flex flex-column  mb-2 lg:col-2 col-2 lg:mb-0" style={{width:"16%"}} key={index}>
                                <input
                                    className="otp-input"
                                    value={value}
                                    ref={focusValue[index]}
                                    onChange={ (e) => handleOtpInput(index,e.target.value) }
                                    autoFocus={index === 0}
                                    onKeyDown={ (e) => handlekeyDown(index, e) }
                                />
                            </div>
                        ))}
                    </div>
                    <div className="col-12 text-center flex justify-content-center align-items-center">
                        <p className="text-sm my-2  text-center "> didn't received OTP? </p>
                        {
                            isActiveResendOTP ? <button className="resend-otp-text" type="button" onClick={handleResentOtp}>Resend OTP</button>
                            :
                            <p className="resend-otp-timer ml-2">Resend OTP in <span className="seconds-timer font-bold">00:{seconds}</span></p>
                        }
                    </div>
                    <div className="mt-2 col-12 text-center">
                        <ReCAPTCHA
                            sitekey={"6LdVROQqAAAAABqhwHnA0kohvU-cb3sfyiJbzNa8"}
                            onChange={handleCaptchaChange}
                            ref={captchaRef}
                        />
                    </div>
                    <div className="mt-1 col-12">
                        <Button label="LOGIN" className="w-12 p-2 login-btn" type="submit" />
                    </div>
                </form>
            </div>
        </div>
    )
}

export default VerifyOtp